module.exports = __webpack_public_path__ + "static/media/Workday_Step2b_Image7g.cbaf74ff.jpg";